import type { ImportRowError } from '@nucleus-commerce/api-client/admin';

/** RFC 4180 quoting; a leading formula character is neutralised so a spreadsheet will not run it. */
export function csvCell(value: string | number | null): string {
  if (value === null) return '';
  let text = String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

export function rowErrorsToCsv(
  errors: readonly ImportRowError[],
  header: readonly [row: string, field: string, message: string],
): string {
  const lines = [header.map(csvCell).join(',')];
  for (const error of errors) {
    lines.push([error.row, error.field, error.message].map(csvCell).join(','));
  }
  return `${lines.join('\r\n')}\r\n`;
}
